import Tab from 'vux/src/components/tab/tab.vue'
import TabItem from 'vux/src/components/tab/tab-item.vue'

export default {
name: 'myVoucher',
components: {
Tab,
TabItem,
},
data () {
return {
voucherList: [],
voucherType: '0'
}
},
methods: {
getVoucher () {
this.$request.post('/couponDetail/couponList',{
status: this.voucherType
}).then(data => {
if(data.code == 0){









let date = (new Date()).toLocaleDateString().replace(/\//g,',')
let start = new Date(date)
function end (b) {
return new Date(b)
}
data.obj.forEach((item, index) => {
if(item.status == '0'){
(end(item.endTime.replace(/-/g,','))-start)/(1000*60*60*24) < 15 ? item.beAboutToExpire = true : item.beAboutToExpire = false





}
});
this.voucherList = data.obj



for(var i=0;i<this.voucherList.length;i++){



if(this.voucherList[i].endTime.split('-')[0]=='2022'){




var img=''
if(this.voucherList[i].type.indexOf("满减") != -1){//满减优惠券



if(this.voucherType=='0'){

if (this.voucherList[i].amt == 20) {
img = require('../../assets/images/YD20.png')
} else if (this.voucherList[i].amt == 30) {
img =  require('../../assets/images/YD30.png')
} else if (this.voucherList[i].amt == 50) {
img =  require('../../assets/images/YD50.png')
} else if (this.voucherList[i].amt == 100) {
img =  require('../../assets/images/YD100.png')
} else if (this.voucherList[i].amt == 200) {
img =  require('../../assets/images/YD200.png')
} else if (this.voucherList[i].amt == 300) {
img =  require('../../assets/images/YD300.png')
}

}else if(this.voucherType=='1'){
if (this.voucherList[i].amt == 20) {
img = require('../../assets/images/Y1D20.png')
} else if (this.voucherList[i].amt == 30) {
img =  require('../../assets/images/Y1D30.png')
} else if (this.voucherList[i].amt == 50) {
img =  require('../../assets/images/Y1D50.png')
} else if (this.voucherList[i].amt == 100) {
img =  require('../../assets/images/Y1D100.png')
} else if (this.voucherList[i].amt == 200) {
img =  require('../../assets/images/Y1D200.png')
} else if (this.voucherList[i].amt == 300) {
img =  require('../../assets/images/Y1D300.png')
}
}else{
if (this.voucherList[i].amt == 20) {
img = require('../../assets/images/Y2D20.png')
} else if (this.voucherList[i].amt == 30) {
img =  require('../../assets/images/Y2D30.png')
} else if (this.voucherList[i].amt == 50) {
img =  require('../../assets/images/Y2D50.png')
} else if (this.voucherList[i].amt == 100) {
img =  require('../../assets/images/Y2D100.png')
} else if (this.voucherList[i].amt == 200) {
img =  require('../../assets/images/Y2D200.png')
} else if (this.voucherList[i].amt == 300) {
img =  require('../../assets/images/Y2D300.png')
}
}



this.voucherList[i]['img']=img



}else{//新人券




if(this.coupon=='0'){
if(this.voucherList[i].amt==20){
img=require('../../assets/images/XA20.png')
}else if(this.voucherList[i].amt==30){
img=require('../../assets/images/XA30.png')
}else if(this.voucherList[i].amt==50){
img=require('../../assets/images/XA50.png')
}
}else if(this.coupon=='1'){
if(this.voucherList[i].amt==20){
img=require('../../assets/images/XB20.png')
}else if(this.voucherList[i].amt==30){
img=require('../../assets/images/XB30.png')
}else if(this.voucherList[i].amt==50){
img=require('../../assets/images/XB50.png')
}
}else{
if(this.voucherList[i].amt==20){
img=require('../../assets/images/XC20.png')
}else if(this.voucherList[i].amt==30){
img=require('../../assets/images/XC30.png')
}else if(this.voucherList[i].amt==50){
img=require('../../assets/images/XC50.png')
}
}
this.voucherList[i]['img']=img


}








}else{
if(this.voucherType=='0'){
if(this.voucherList[i].type=='满减优惠券'){
if(this.voucherList[i].amt==20){
this.voucherList[i]['img']=require("../../assets/images/Q20.png");
}else if(this.voucherList[i].amt==50){
this.voucherList[i]['img']=require("../../assets/images/Q50.png");
}else if(this.voucherList[i].amt==100){
this.voucherList[i]['img']=require("../../assets/images/Q100.png");
}else if(this.voucherList[i].amt==200){
this.voucherList[i]['img']=require("../../assets/images/Q200.png");
}else if(this.voucherList[i].amt==500){
this.voucherList[i]['img']=require("../../assets/images/Q500.png");
}else if(this.voucherList[i].amt==1000){
this.voucherList[i]['img']=require("../../assets/images/Q1000.png");
}
this.voucherList[i]['title']='待使用'

}else{// 新人券
if(this.voucherList[i].amt==20){
this.voucherList[i]['img']=require("../../assets/images/XA20.png");
}else if(this.voucherList[i].amt==30){
this.voucherList[i]['img']=require("../../assets/images/XA30.png");
}else if(this.voucherList[i].amt==50){
this.voucherList[i]['img']=require("../../assets/images/XA50.png");
}

}


}else if(this.voucherType=='1'){//已使用
if(this.voucherList[i].type=='满减优惠券'){
if(this.voucherList[i].amt==20){
this.voucherList[i]['img']=require("../../assets/images/Q20.png");
}else if(this.voucherList[i].amt==50){
this.voucherList[i]['img']=require("../../assets/images/Q50.png");
}else if(this.voucherList[i].amt==100){
this.voucherList[i]['img']=require("../../assets/images/Q100.png");
}else if(this.voucherList[i].amt==200){
this.voucherList[i]['img']=require("../../assets/images/Q200.png");
}else if(this.voucherList[i].amt==500){
this.voucherList[i]['img']=require("../../assets/images/Q500.png");
}else if(this.voucherList[i].amt==1000){
this.voucherList[i]['img']=require("../../assets/images/Q1000.png");
}
this.voucherList[i]['title']='已使用'

}else{// 新人券
if(this.voucherList[i].amt==20){
this.voucherList[i]['img']=require("../../assets/images/XB20.png");
}else if(this.voucherList[i].amt==30){
this.voucherList[i]['img']=require("../../assets/images/XB30.png");
}else if(this.voucherList[i].amt==50){
this.voucherList[i]['img']=require("../../assets/images/XB50.png");
}
}
}else{//已经过期
if(this.voucherList[i].type=='满减优惠券'){
if(this.voucherList[i].amt==20){
this.voucherList[i]['img']=require("../../assets/images/QB20.png");
}else if(this.voucherList[i].amt==50){
this.voucherList[i]['img']=require("../../assets/images/QB50.png");
}else if(this.voucherList[i].amt==100){
this.voucherList[i]['img']=require("../../assets/images/QB100.png");
}else if(this.voucherList[i].amt==200){
this.voucherList[i]['img']=require("../../assets/images/QB200.png");
}else if(this.voucherList[i].amt==500){
this.voucherList[i]['img']=require("../../assets/images/QB500.png");
}else if(this.voucherList[i].amt==1000){
this.voucherList[i]['img']=require("../../assets/images/QB1000.png");
}
this.voucherList[i]['title']='已过期'

}else{// 新人券
if(this.voucherList[i].amt==20){
this.voucherList[i]['img']=require("../../assets/images/XC20.png");
}else if(this.voucherList[i].amt==30){
this.voucherList[i]['img']=require("../../assets/images/XC30.png");
}else if(this.voucherList[i].amt==50){
this.voucherList[i]['img']=require("../../assets/images/XC50.png");
}
}
}

}





}
console.log( this.voucherList);

}else{
this.$vux.toast.show({
type: 'cancel',
text: data.msg
})
}
}).catch(e => {
console.log(e)
})
},
unused () {
this.voucherType = '0'
this.getVoucher()
},
haveBeenUsed () {
this.voucherType = '1'
this.getVoucher()
},
haveExpired () {
this.voucherType = '2'
this.getVoucher()
},
},
created () {
this.getVoucher()
},
mounted() {

}
}



// WEBPACK FOOTER //
// ./src/views/myVoucher/script.js